import { settingConstants } from "../constants";

export function settings(state = {}, action) {
    switch (action.type) {
        case settingConstants.GET_PLATFORM_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case settingConstants.GET_PLATFORM_LIST_SUCCESS:
            return {
                ...state,
                platforms: action.platforms
            };
        case settingConstants.GET_PLATFORM_LIST_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case settingConstants.GET_CHANNEL_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case settingConstants.GET_CHANNEL_LIST_SUCCESS:
            return {
                ...state,
                channels: action.channels
            };
        case settingConstants.GET_CHANNEL_LIST_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case settingConstants.GET_SLA_CALENDER_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case settingConstants.GET_SLA_CALENDER_LIST_SUCCESS:
            return {
                ...state,
                slaCalenders: action.slaCalenders
            };
        case settingConstants.GET_SLA_CALENDER_LIST_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case settingConstants.GETALL_TZ_REQUEST:
            return {
                ...state,
                loading: true
            };
        case settingConstants.GETALL_TZ_SUCCESS:
            return {
                ...state,
                availableTimeZones: action.timeZones
            };
        case settingConstants.GETALL_TZ_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case settingConstants.GETALL_USER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case settingConstants.GETALL_USER_SUCCESS:
            return {
                ...state,
                availableUsers: action.timeZones
            };
        case settingConstants.GETALL_USER_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state;
    }
}